import { all } from "redux-saga/effects";
import loadTokenFromStorage from "./loadTokenFromStorage";
import login from "./login";
import fetchUser from "./fetchUser";
import signOut from "./signOut";
import signUp from "./signUp";
import fetchStripeAccountLinks from "./fetchStripeAccountLinks";
import sendResetPassword from "./sendResetPassword";
import resetPassword from "./resetPassword";
import submitFeedback from "./submitFeedback";
import updateUser from "./updateUser";

export default function* rootSaga(): Generator {
    yield all([
        loadTokenFromStorage(),
        login(),
        fetchUser(),
        signOut(),
        signUp(),
        fetchStripeAccountLinks(),
        sendResetPassword(),
        resetPassword(),
        submitFeedback(),
        updateUser(),
    ]);
}
